// ============================================
// EMPTY STATE COMPONENT
// ============================================

import { ReactNode } from 'react';
import { FileX, Search, FolderOpen } from 'lucide-react';
import { cn } from '@/utils';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  variant?: 'default' | 'search' | 'filter';
  className?: string;
}

const variantIcons = {
  default: FolderOpen,
  search: Search,
  filter: FileX,
};

export function EmptyState({
  icon,
  title,
  description,
  action,
  variant = 'default',
  className,
}: EmptyStateProps) {
  const DefaultIcon = variantIcons[variant];

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-12 px-6 text-center',
        className
      )}
    >
      <div className="flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
        {icon || <DefaultIcon className="h-8 w-8 text-gray-400" />}
      </div>
      <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-gray-500 max-w-sm">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
